import React from "react";

export type IDamageIconProps = {};

const DamageIcon: React.FC<IDamageIconProps> = ({}) => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={38.56}
   height={57.3}
   viewBox="0 0 38.56 57.3"
  >
   <path
    data-name="Path 590"
    d="M36.912 0H1.653A1.653 1.653 0 000 1.653v53.99A1.653 1.653 0 001.649 57.3h11.022a1.653 1.653 0 001.622-1.334L19.282 30.6l4.989 25.363a1.653 1.653 0 001.622 1.334h11.019a1.653 1.653 0 001.653-1.653V1.653A1.653 1.653 0 0036.912 0zm-1.649 32.84l-5.667-.266-1.675-1.674 7.342-1.688zm0-16.1l-3.3-2.2v-4.078h3.3zM3.312 3.305h31.953v3.857H3.312zm0 7.162h3.3v4.074l-3.3 2.2zm0 17.494l5.54 1.274-1.348 1.347-4.192.2zm10.323 14.237l-3.717-.174-1.348-1.348 5.619-1.291zM27.258 53.99l-6.346-32.272a1.653 1.653 0 00-3.243 0l-3.057 15.517-6.491 1.492a2 2 0 00-.966 3.364l1.348 1.347a2 2 0 001.32.584l3.42.16-1.932 9.808h-8V32.781l4.286-.2a1.994 1.994 0 001.32-.584l1.348-1.347a2 2 0 00-.966-3.364L3.311 25.91v-5.191l5.873-3.918a1.651 1.651 0 00.736-1.375v-4.958h18.731v4.958a1.651 1.651 0 00.736 1.375l5.875 3.917v6.443l-7.79 1.791a2 2 0 00-.966 3.363l1.675 1.675a2 2 0 001.32.583l5.761.27v19.148z"
    fill="#7c7c7c"
   />
  </svg>
 );
};

export { DamageIcon };
